import React from 'react';

import Grid from '@material-ui/core/Grid';

import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';

type InputProps = {
  requiredLicenseNames: string[];
};

export const RequiredLicenseWarning = ({ requiredLicenseNames }: InputProps) => {
  const driversLicenceRegex = /(Driver'?s? License|CDL|Class [ABC])/i;
  const hasRequiredNonDriversLicenses =
    requiredLicenseNames.filter((name) => !driversLicenceRegex.test(name)).length > 0;

  return !hasRequiredNonDriversLicenses ? null : (
    <Grid
      container
      direction="row"
      alignItems="center"
      spacing={2}
      className="u-background-messageWarning u-padding-md u-margin-top-md"
    >
      <Grid item xs={1}>
        <MaterialDesignIcon iconName={ICON_NAMES.WARNING} />
      </Grid>
      <Grid item xs={11}>
        Requiring licenses other than those that are absolutely critical can deter applicants.
      </Grid>
    </Grid>
  );
};
